<template>
    <v-container fluid>
        <v-card flat class="px-2">
             <v-card-title class="notification-count d-flex justify-space-between">
                <span>Notification Report Count</span>
                <router-link slot="right" :to="{ name: 'notficationTrigger' }">
                  <v-btn elevation="1" absolute right top>
                    <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
                    </router-link>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                            v-model="search" style="width: 15%;"
                            label="Search"
                            append-icon="mdi-magnify"
                            single-line
                            hide-details
                        ></v-text-field>
                        </v-card-text>
                        <v-card-text>
                            <v-data-table
                                :headers="headers"
                                :items="filteredNotificationData"
                                :items-per-page="10"
                                item-key="name"
                            >
                            </v-data-table>
                        </v-card-text>
                </v-card>
        </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
export default {
  name: 'reportNotificationcount',
  data () {
    return {
      headers: [
        { text: 'Module Name', align: 'start', sortable: false, value: 'moduleName' },
        { text: 'Ref Parameter', value: 'ref' },
        { text: 'UserType', value: 'userType' },
        { text: 'Triggerdate', value: 'triggerDate' },
        { text: 'Triggertime', value: 'triggerTime' },
        { text: 'NotificationCount', value: 'notificationCount', align: 'center', sortable: false }
      ],
      notificationData: [],
      search: ''
    }
  },
  created () {
    this.getNotificationcountList()
  },
  computed: {
    filteredNotificationData () {
      if (!this.search) {
        return this.notificationData
      }
      return this.notificationData.filter(item => {
        const moduleNameMatch = item.moduleName.toLowerCase().includes(this.search.toLowerCase())
        const refMatch = item.ref ? item.ref.toLowerCase().includes(this.search.toLowerCase()) : false
        return moduleNameMatch || refMatch
      })
    }
  },
  methods: {
    getNotificationcountList: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/admin/app-notification/Reportcount`)
        if (res.status === 200) {
          this.notificationData = res.data.data
          this.notificationData.forEach(item => {
            const url = new URL(item.moduleURL, window.location.origin)
            const refParam = url.searchParams.get('ref')
            if (refParam) {
              item.ref = refParam
            }
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}
</script>
